import React from 'react';
import { RegistrationStepConfig, RegistrationStepIds } from '../../components/Registration/types';
import { useTranslations } from '../useTranslationsHelper';
import { RegistrationFormStep } from '../../components/Registration/steps/RegistrationFormStep';
import { RegistrationStepperStep } from '../../components/Registration/stepper';
import { useRegistrationOuterSteps } from './useRegistrationOuterSteps';
import { useUserContext } from '../../providers/UserProvider';
import { BRANDS } from '../../components/Itv/types';

export const useRegistrationSteps = (): RegistrationStepConfig[] => {
  const { t } = useTranslations();
  const outerSteps = useRegistrationOuterSteps();
  const { theme } = useUserContext();

  const title = t(
    theme === BRANDS.BINGO ? 'register.steps.account.credentials.bingo' : 'register.steps.account.credentials.spins'
  );

  return [
    {
      id: RegistrationStepIds.AccountDetails,
      title,
      shortTitle: t('register.steps.account.credentials.short'),
      backEnabled: false,
      isUserHaveAccountText: true,
      introText: <span>{t('register.steps.account.email-description')}</span>,
      StepComponent: RegistrationFormStep,
      StepperStepComponent: RegistrationStepperStep,
      fieldSets: [
        {
          id: 'registration-account-details-fieldset',
          labelSrOnly: true,
          fields: [{ name: 'email' }, { name: 'password' }],
        },
      ],
    },
    {
      id: RegistrationStepIds.PersonalDetails,
      title: t('register.steps.personal.title'),
      shortTitle: 'Personal details',
      StepComponent: RegistrationFormStep,
      StepperStepComponent: RegistrationStepperStep,
      backEnabled: true,
      fieldSets: [
        {
          id: 'registration-personal-details-fieldset',
          fields: [{ name: 'honorificPrefix' }, { name: 'givenName' }, { name: 'familyName' }, { name: 'birthDate' }],
        },
      ],
    },
    {
      id: RegistrationStepIds.AddressDetails,
      title: t('register.steps.address.title'),
      shortTitle: 'Address details',
      StepComponent: RegistrationFormStep,
      StepperStepComponent: RegistrationStepperStep,
      backEnabled: true,
      submissionStep: true,
      fieldSets: [
        {
          id: 'registration-address-details-fieldset',
          fields: [{ name: 'addrStreetAddress' }, { name: 'addrLocality' }, { name: 'addrPostalCode' }],
        },
        {
          id: 'registration-details',
          fields: [{ name: 'mobileNumber' }],
        },
        {
          id: 'registration-marketing-preferences-fieldset',
          label: t('register.step.preferences'),
          fields: [
            {
              name: 'marketingConsentsParagraph',
              columns: 12,
            },
            {
              name: 'marketingPreferences',
              columns: 12,
            },
          ],
        },
        {
          id: 'registration-terms-details-fieldset',
          label: '',
          fields: [{ name: 'acceptTerms' }],
        },
      ],
    },
    ...outerSteps,
  ];
};
